import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
export const wrapperStaticStyle = css({
    position: 'relative',
    width: '100%',
});
export function wrapperStyle({ inverted }) {
    return [...(inverted ? [darkThemeStyle] : []), wrapperStaticStyle];
}
export const labelStaticStyle = css({
    color: theme.text.main,
    display: 'flex',
    fontWeight: tokens.fontWeights.bold,
    lineHeight: tokens.lineHeights.default,
    marginBottom: tokens.spacing.small,
});
export const descriptionStaticStyle = css({
    lineHeight: tokens.lineHeights.default,
    marginTop: `-${tokens.spacing.xsmall}`,
});
const requiredIndicatorStaticStyle = css({
    alignItems: 'center',
    color: theme.text.subtle,
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'end',
    textAlign: 'right',
    textTransform: 'capitalize',
    userSelect: 'none',
});
export function requiredIndicatorStyle({ size }) {
    return [
        requiredIndicatorStaticStyle,
        css({
            fontSize: size === 'small' ? tokens.fontSizes.xsmall : tokens.fontSizes.small,
        }),
    ];
}
const requiredDotStaticStyle = css({
    backgroundColor: theme.red.darker,
    borderRadius: tokens.borderRadius.circle,
    display: 'inline-block',
    flexShrink: 0,
    marginRight: tokens.spacing.xsmall,
});
export function requiredDotStyle({ size }) {
    return [
        requiredDotStaticStyle,
        css({
            height: size === 'small' ? 4 : 6,
            width: size === 'small' ? 4 : 6,
        }),
    ];
}
export const errorStaticStyle = css({
    color: theme.error.text,
    lineHeight: tokens.lineHeights.default,
    marginTop: tokens.spacing.small,
});
